module.exports = __webpack_public_path__ + "static/media/mgm_interior3.628a4b4e.jpg";